// @ts-nocheck
import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';

import { Brand } from 'models/propTypes/tile';
import { useNetworkName } from 'hooks/kitchenSink';
// import TickerText from 'components/common/TickerText';
import classNames from 'classnames';

import styles from './EventTitle.module.scss';

const messages = {
  dot: {
    id: 'common.dot',
    description: 'dot',
  },
};

// Rules:
// Ticker only needs to occur on content with a network logo underneath
// It style will not occur on titles that span more than one line
//
const EventTitle = ({ prefix, title, brand }) => {
  const intl = useIntl();
  const networkName = useNetworkName(brand);

  const headerEl = prefix ? (
    <React.Fragment>
      <span className={styles.prefix}>{prefix}</span>
      <span>
        {' '}
        {intl.formatMessage(messages.dot)} {networkName}
      </span>
    </React.Fragment>
  ) : (
    networkName
  );

  return (
    <div data-testid="tile-title">
      <div className={classNames('text-truncate', styles.header)}>
        {headerEl}
      </div>
      <div className={classNames('text-truncate', styles.title)}>{title}</div>
      {/* {shouldScroll ? (
        <TickerText>{title}</TickerText>
      ) : (
        <div className="text-truncate">{title}</div>
      )} */}
    </div>
  );
};

EventTitle.propTypes = {
  prefix: PropTypes.string,
  title: PropTypes.string.isRequired,
  brand: Brand,
  // shouldScroll: PropTypes.bool,
};

EventTitle.defaultProps = {
  prefix: null,
  // shouldScroll: false,
  brand: null,
};

export default EventTitle;
